import { makeStyles, Container, Paper, ListItem, ListItemText, Grid, Divider, Box, List, Fab, Checkbox, FormControlLabel, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, MenuItem, Menu } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react';
//import { blueGrey, green, grey, orange, red, yellow } from '@material-ui/core/colors';


import DataContext from '../../context/dataContext';
import AuthContext from '../../context/authContext';

// Icons
import AddIcon from '@material-ui/icons/Add';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import FilterListIcon from '@material-ui/icons/FilterList';
//import Update from '@material-ui/icons/Update';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Link } from 'react-router-dom';
import { TypeIcons } from './TypeIcons';
import { generateRelations, IncludeRelationsToDatabase } from '../visualisation/generateRelations';
import { DeleteLink } from '../../graphqlCommunication/LinksInterface';
import ClearIcon from '@material-ui/icons/Clear';
import { TooltipStyle } from '../basicComponents/HtmlTooltip';
import parse from 'html-react-parser'
import Brightness1Icon from '@material-ui/icons/Brightness1';
import BubbleChartSharpIcon from '@material-ui/icons/BubbleChartSharp';
import { theme } from '../../theme';


// Syles
const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(9),
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        background: "lightgray",
        height: "100vh",
        maxWidth: "none",
    },
    paper: {
        height: `calc(100% - ${theme.spacing(4)}px)`,
        padding: theme.spacing(2),
    },
    list: {
        height: `calc(100% - ${theme.spacing(8)}px)`,
        overflow: 'auto',
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
    },
    listItem: {
        color: theme.palette.primary.light,
        /*  marginTop: theme.spacing(0),
         marginBottom: theme.spacing(0),
         paddingTop: theme.spacing(1),
         paddingBottom: theme.spacing(1), */
    },
    listItemDomain: {
        color: theme.palette.primary.dark,
        background: theme.palette.background.light,
        /*  marginTop: theme.spacing(0),
         marginBottom: theme.spacing(0),
         paddingTop: theme.spacing(1),
         paddingBottom: theme.spacing(1), */
    },
    listTextItem: {
        color: theme.palette.primary.light,
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
    dividerTop: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
    },
    dividerBottom: {
        marginTop: theme.spacing(0),
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
    },
    textField: {
        height: "20"
    },
    fab: {
        color: theme.palette.primary.contrastText,
        background: theme.palette.secondary.main,
        marginLeft: theme.spacing(1),
    },
    avatar: {
        marginRight: theme.spacing(2),
        color: '#fff',
        backgroundColor: theme.palette.secondary.dark,
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    checkbox: {
        marginLeft: theme.spacing(1),
    },
    statusIcon: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

// Main Function
export const TermTable = ({ setDawerStateDetailView, setReloadContetnt, domainMap }) => {
    const classes = useStyles();

    // Use Context
    const contextType = useContext(AuthContext);
    const dataContext = useContext(DataContext);
    const token = contextType.token;
    const termArray = dataContext.termArray;
    //const termItem = dataContext.termItem;
    const setTermArray = dataContext.setTermArray;
    const setTermItem = dataContext.setTermItem;
    const linkArray = dataContext.linkArray;
    const setLinkArray = dataContext.setLinkArray;

    // UseState Constances
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showType, setShowType] = useState(true);
    const [showStatus, setShowStatus] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    console.log("------------ termArray")
    console.log(termArray)


    // Component Functions
    const handleChange = e => {
        setSearchTerm(e.target.value);
    };

    const handleResetSearch = e => {
        setSearchTerm("");
    };

    const handleShowType = e => {
        setShowType(!showType)
    }

    const handleShowStatus = e => {
        setShowStatus(!showStatus)
    }

    const handleClickFilter = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseFilter = () => {
        setAnchorEl(null);
    };

    const ITEM_HEIGHT = 48;


    // Sort Alphabetic
    function compare(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    }


    useEffect(() => {
        const results = termArray.filter(val =>
            val.name.toLowerCase().includes(searchTerm.toLowerCase()) || val.abbreviation.toLowerCase().includes(searchTerm.toLowerCase())
        );
        results.sort(compare);
        setSearchResults(results);
    }, [searchTerm, termArray]);

    // Update when termArray is change
    useEffect(() => {
        //updateLinkHandle()
    }, [searchTerm, termArray]);

    // Highlighting current selection
    const [itemSelected, setItemSelected] = useState();
    const updateSelected = (index) => {
        setItemSelected(index)
    };


    /* console.log("termArray")
    termArray.map((val) =>{
        console.log(val.abbreviation)
    }) */


    // Map all Data into the list Items
    const filterList = searchResults.map((val, index) => {
        let primaryName = val.name

        // This is an ugly hack because of dirty Database
        if (val.abbreviation !== "" && val.abbreviation !== "test" && val.abbreviation !== "abb" && val.abbreviation !== "abbreviation") primaryName = primaryName + " (" + val.abbreviation + ")"

        val.relations = 0;
        if (linkArray) {
            val.relations = linkArray.filter(link => (link.toId === val._id || link.fromId === val._id)).length
        }
        const key = `listItems-${index}`;

        // Function Click on Item
        const itemClichFunction = (() => {
            setTermItem(val);
            setDawerStateDetailView(true);
            updateSelected(index)
            //console.log("Item was Selected:")
            //console.log("name: " + val.name)
        })
        //() => { setTermItem(val); setDawerStateDetailView(true); updateSelected(index) }

        //let desc = val.description
        if (val.description === undefined) {
            val.description = "No Description"
        }
        let desc = parse(val.description)
        if (val.description.slice(0, 3) === "<p>") {
            desc = val.description.slice(3, val.description.indexOf("</p>"))
        }

        let secondaryCellContent = ""
        try {
            secondaryCellContent = parse(desc.substring(0, 50).concat(' ...'))
        } catch (error) {
            console.log("Error in parsing")
            console.log(error)
        }


        // Check if there is a View:
        if (val.views.length !== 0) {
            console.log(val.views.length)
        }

        let isDomain = false
        domainMap.map((domainSpace) => {
            if (domainSpace === val.name) {
                console.log("Domain Space: " + val.name)
                isDomain = true
                return;
            }
        })

        return (
           /*  <TooltipStyle title={isDomain && "I am a domain!"}> */
                <ListItem className={isDomain ? classes.listItemDomain : classes.listItem} button onClick={itemClichFunction} key={key} selected={itemSelected === index}>
                    {showType && (
                        <>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <>
                                    {/* Haupt-Icon */}
                                    <TypeIcons type={val.type} />

                                    {/* Überlagerndes Icon */}
                                </>
                                {showStatus &&
                                    <>
                                        <Brightness1Icon
                                            className={classes.statusIcon}
                                            style={{
                                                position: 'absolute', // Absolut positioniert relativ zum übergeordneten Element
                                                top: -7, // Verschieben nach oben
                                                right: -15, // Verschieben nach rechts
                                                color: 'white',
                                                fontSize: '14px',
                                            }}
                                        />
                                        <TooltipStyle title={val.status}>
                                            <Brightness1Icon
                                                className={classes.statusIcon}
                                                style={{
                                                    position: 'absolute', // Absolut positioniert relativ zum übergeordneten Element
                                                    top: -6, // Verschieben nach oben
                                                    right: -14, // Verschieben nach rechts
                                                    color: val.status === 'Draft' ? theme.palette.typeColors.orange : val.status === 'Released' ? theme.palette.typeColors.green : theme.palette.typeColors.blueGrey,
                                                    fontSize: '12px',
                                                }}
                                            />
                                        </TooltipStyle>
                                    </>
                                }
                            </div>
                        </>
                    )}

                    {!showType && (
                        <>
                            <ListItemText
                                className={classes.listTextItem}
                                primary={primaryName}
                            />
                        </>
                    )}

                    {showType && (
                        <>
                            <ListItemText
                                className={classes.listTextItem}
                                primary={
                                    <>
                                        {primaryName}
                                        {val.views.length !== 0 &&

                                            <TooltipStyle title="This Term has an defined View">
                                                <BubbleChartSharpIcon
                                                    className={classes.statusIcon}
                                                    style={{
                                                        color: theme.palette.primary.main,
                                                        fontSize: '16px',
                                                    }}
                                                />
                                            </TooltipStyle>

                                        }
                                    </>
                                }
                                secondary={secondaryCellContent}
                            /* secondary={parse(val.description.substring(0, 50).concat(' ...'))} */
                            />

                        </>
                    )}

                    <span className={classes.listTextItem} >{val.relations > 0 && val.relations}</span>
                </ListItem>
           /*  </TooltipStyle> */
        )
    });


    // Update Link Array (This ins possibl needed because of linkArray.map)
    const [tmpLinkArray, setTmpLinkArray] = useState(linkArray);
    useEffect(() => {
        setLinkArray(tmpLinkArray)
    }, [tmpLinkArray, setLinkArray]);


    const handelReloadContent = () => {
        setReloadContetnt(Math.random)
    }

    // Generate Links
    const updateLinkHandle = () => {
        // Make a Array with all TermIDs  
        let termIDmap = []
        //console.log(termArray)
        termArray.map((term, index) => {
            termIDmap[index] = term._id
        })

        // Generate Links 
        const relations = generateRelations(termArray);
        // Remove Auto Relatins if thay are deleted in the Termdescription
        linkArray.map(link => {
            if (link.description === "autoLink") {
                // Check if the Link fitting to the preseted Terms (Needed for different Domain Spaces)
                if (termIDmap.includes(link.fromId) || termIDmap.includes(link.toId)) {
                    // Check if Autolinks are still relevant.
                    const existingRel = relations.find(obj => (link.fromId === obj.source && link.toId === obj.target));
                    if (!existingRel) {
                        DeleteLink(link._id, setTmpLinkArray, tmpLinkArray, contextType.token)
                    }
                }
            }
            return link;
        })
        // Include Relations to database
        IncludeRelationsToDatabase(relations, linkArray, setLinkArray, contextType.token)
    };

    // Return
    return (
        <Container className={classes.container}>
            <Paper className={classes.paper}>
                <Grid container spacing={1}>

                    <div style={{ width: '100%' }}>
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="flex-end"
                        >
                            <Box flexGrow={1} >

                                <FormControl variant="outlined" size="small">
                                    <InputLabel htmlFor="outlined-adornment-password">Search..</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type='text'
                                        value={searchTerm}
                                        onChange={handleChange}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                {searchTerm &&
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleResetSearch}
                                                        onMouseDown={handleResetSearch}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        <ClearIcon />
                                                    </IconButton>
                                                }
                                            </InputAdornment>
                                        }
                                        labelWidth={70}
                                    />
                                </FormControl>
                            </Box>
                            <Box>

                                <IconButton
                                    className={classes.fabOrientation}
                                    aria-label="more"
                                    aria-controls="long-menu"
                                    aria-haspopup="true"
                                    color="inherit"
                                    onClick={handleClickFilter}
                                >
                                    <FilterListIcon />
                                </IconButton>

                                <Menu
                                    id="long-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={open}
                                    onClose={handleCloseFilter}
                                    PaperProps={{
                                        style: {
                                            maxHeight: ITEM_HEIGHT * 4.5,
                                            width: '20ch',
                                        },
                                    }}
                                >

                                    <MenuItem >
                                        <FormControlLabel
                                            className={classes.checkbox}
                                            control={
                                                <TooltipStyle title={"Details"}>
                                                    <Checkbox
                                                        checked={showType}
                                                        onChange={handleShowType}
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />
                                                </TooltipStyle>
                                            }
                                            label="Details"
                                        />
                                    </MenuItem>
                                    <MenuItem >
                                        <FormControlLabel
                                            className={classes.checkbox}
                                            control={
                                                <TooltipStyle title={"Status"}>
                                                    <Checkbox
                                                        checked={showStatus}
                                                        onChange={handleShowStatus}
                                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    />
                                                </TooltipStyle>
                                            }
                                            label="Status"
                                        />
                                    </MenuItem>

                                </Menu>



                            </Box>
                            {contextType.permission !== "read" && (
                                <Box>
                                    <Link to="/edit" className={classes.link}>
                                        <TooltipStyle title={"Add new term"}>
                                            <Fab
                                                className={classes.fab}
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                aria-label="more"
                                                size="small" ><AddIcon />
                                            </Fab>
                                        </TooltipStyle>
                                    </Link>
                                </Box>
                            )}
                            {contextType.permission !== "read" && (
                                <Box>
                                    <TooltipStyle title={"Reload from database"}>
                                        <Fab
                                            className={classes.fab}
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            aria-label="more"
                                            size="small"
                                            onClick={handelReloadContent}><RefreshIcon />
                                        </Fab>
                                    </TooltipStyle>
                                </Box>
                            )}
                        </Box>
                    </div>

                </Grid>
                <Divider className={classes.dividerTop} />
                <Box className={classes.list}>
                    <List>{filterList}</List>
                </Box>
                <Divider className={classes.dividerBottom} />
            </Paper>
        </Container >
    );
}

